import * as React from "react";
import "../styles/Modal.css";
import ReactModal from "react-modal";
import { createWinder, DropdownList } from "../api/dataTypes";


interface State {
    winder:createWinder;
    orgIndex:number;
}

export interface Props {
  isModalOpen: boolean;
  closeModal: () => void;
  addWinder: (newWinder:createWinder, orgIndex:number) => void;
  orgOptions: DropdownList[];
}

export class AddWinderModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
        winder: {
            name:"",
            location:"",
            serialNumber:"",
            macAddress:"",
            customerId:null,
            distributorId:null,
        },
        orgIndex:-1
    }
  }

  componentWillReceiveProps(nextProps:Props){
    if (!nextProps.isModalOpen || (nextProps.orgOptions.length!==0)) {
      if(nextProps.orgOptions.length===1){
        this.setState({
          orgIndex:0,
        })
      }
    }
  }

  render() {
    return (
        <div className="Modal">
            <ReactModal
            ariaHideApp={false}
            isOpen={this.props.isModalOpen}
            shouldCloseOnEsc={true}
            shouldCloseOnOverlayClick={true}
            onRequestClose={this.props.closeModal}
            className={{
              base: "modal-content edit-modal",
              afterOpen: "modal-content_after-open",
              beforeClose: "modal-content_before-close"
            }}
            overlayClassName={{
              base: "modal-overlay",
              afterOpen: "modal-overlay_after-open",
              beforeClose: "modal-overlay_before-close"
            }}
            >
                <div className="container edit-modal">
                    <label className="label-large col-form-label">
                            Add Spool Winder
                    </label>
                    <div className="row form-group" />
                    <div className="row form-group d-flex align-items-center">
                    <div className="col-4 modal-text">Winder Name</div>
                        <div className="col-8">
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.winder.name}
                                onChange={this.onInputChange}
                                name="name"
                                tabIndex={1}
                                autoFocus={true}
                            />
                        </div>
                    </div>
                    <div className="row form-group d-flex align-items-center">
                        <div className="col-4 modal-text">Location</div>
                        <div className="col-8">
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.winder.location}
                                onChange={this.onInputChange}
                                name="location"
                                tabIndex={2}
                            />
                        </div>
                    </div>
                    <div className="row form-group d-flex align-items-center">
                        <div className="col-4 modal-text">PLC Serial #</div>
                        <div className="col-8">
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.winder.serialNumber}
                                onChange={this.onInputChange}
                                name="serialNumber"
                                tabIndex={3}
                            />
                        </div>
                    </div>
                    <div className="row form-group d-flex align-items-center">
                        <div className="col-4 modal-text">PLC Mac Address</div>
                        <div className="col-8">
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.winder.macAddress}
                                onChange={this.onInputChange}
                                name="macAddress"
                                tabIndex={4}
                            />
                        </div>
                    </div>
                    <div className="row form-group d-flex align-items-center">
                        <div className="col-4 modal-text">Organization</div>
                        <div className="col-8">
                            <select
                                className="dropdown-style"
                                value={this.state.orgIndex}
                                onChange={this.onChange}
                                tabIndex={5}
                            >
                                {this.props.orgOptions.map(c =>
                                    <option key={c.value} value={c.value} >
                                        {c.name}
                                    </option>)
                                }
                            </select>
                        </div>
                    </div>
                    <div className="row form-group">
                        <div className="col">
                            <button
                                className="btn btn-block button-standard confirm-button"
                                disabled={this.state.winder.name===""
                                    || this.state.winder.serialNumber===""
                                }
                                tabIndex={6}
                                onClick={this.confirmButtonPressed}
                            >
                                Confirm
                        </button>
                        </div>
                        <div className="col">
                            <button
                                className="btn btn-block button-standard cancel-button"
                                tabIndex={7}
                                onClick={this.cancelButtonPressed}
                            >
                                Close/Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </ReactModal>
        </div>
    )
  }

  private onInputChange = (
        e:
            | React.SyntheticEvent<HTMLInputElement>
            | React.SyntheticEvent<HTMLSelectElement>
    ) => {
        let newWinder = this.state.winder;
        newWinder[e.currentTarget.name] = e.currentTarget.value;
        this.setState({
            winder: newWinder
        });
    }

    private confirmButtonPressed = () => {
        // Call change password method that was passed in
        this.props.addWinder(this.state.winder, this.state.orgIndex
        );
        this.props.closeModal();
    }

    private cancelButtonPressed = () => {
        this.setState({
            winder: {
                name:"",
                location:"",
                serialNumber:"",
                macAddress:"",
                customerId:null,
                distributorId:null,
            },
            orgIndex:-1,
        });
        this.props.closeModal();
    }

    private onChange = (e: React.SyntheticEvent<HTMLSelectElement>) => {
        // First try to parse the value that was sent - if it fails, do nothing
        let parsedNumber = parseInt(e.currentTarget.value, 10);

        if (!isNaN(parsedNumber)) {
            // Element in the dropdown has been selected
            this.setState({
                orgIndex: parsedNumber,
            });
        }
    }
}